export default class Search {
   attachSearch(element) {
      $('#' + element).change(function(evt) {
         evt.preventDefault();
         $(evt.target).closest('form').submit();
      });
   }
}
